<template>
  <v-container
    grid-list-md
    :class="['mx-auto', 'mb-12', 'mt-6']"
    style="max-width: 1140px"
  >
    <v-card
      color="red darken-4"
      dark
      v-if="filter.codmarca.length != 0 && tamFitro === 0"
    >
      <v-card-text>
        <v-row align="center">
          <v-col class="display-1" cols="12">
            <v-icon>mdi-alert</v-icon>{{ mensaje }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <Loading v-if="loadingSubCat" />
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { Loading } from "./LoadingDomo";
export default {
  components: { Loading },
  name: "gridQueryMsg",
  props: {
    mensaje: String,
    tamFitro: Number,
  },
  computed: {
    ...mapState(["filter", "loadingSubCat"]),
    ...mapGetters(["filterconsolidado"]),
  },
  methods: {
    ...mapMutations([
      "CLR_BUSCARSCAT",
      "CLR_BUSCARMARCA",
      "CLR_BUSCARQUERY",
      "CLR_BUSCARPROMO",
      "CLR_PRECIO",
    ]),
    limpiaconsulta() {
      /* this.CLR_BUSCARPROMO();
        this.CLR_BUSCARSCAT();
        this.CLR_BUSCARMARCA();*/
      this.CLR_BUSCARMARCA();
    },
  },
};
</script>

<style></style>
